import * as api from "@/common/api";
import { LottoGame } from "../class/index";

export const getMixStandard = async () => {
  //
  // const result = await api.get("/api/v1/lotto/game/mix/standard");
  // console.log("getLottoResult res: ", result);

  // const list: LottoGame[] = [];
  // result.data.forEach((element: LottoGame) => {
  //   console.log("element : ", element);
  //   const lottoGame = new LottoGame();
  //   lottoGame.bind(element);
  //   list.push(lottoGame);
  // });

  // return list;

  const { data } = await api.get("/api/v1/lotto/game/mix/standard");
  console.log("getLottoResult res: ", data);

  // map을 사용하여 데이터를 변환 및 리스트 생성
  const list = data.map((element: LottoGame) => {
    const lottoGame = new LottoGame();
    lottoGame.bind(element); // bind가 데이터 바인딩을 한다고 가정
    return lottoGame;
  });

  return list;
};

export const getMixShowCount = async () => {
  const { data } = await api.get("/api/v1/lotto/game/mix/show-count");
  console.log("getLottoResult res: ", data);

  // map을 사용하여 데이터를 변환 및 리스트 생성
  const list = data.map((element: LottoGame) => {
    const lottoGame = new LottoGame();
    lottoGame.bind(element); // bind가 데이터 바인딩을 한다고 가정
    return lottoGame;
  });

  return list;
};

/** 완전 랜덤 게임 생성 */
export const getRandom = async (size = 5): Promise<LottoGame[]> => {
  const { data } = await api.get("/api/v1/lotto/game/random/" + size);
  return data.map((el: LottoGame) => {
    const g = new LottoGame();
    g.bind(el);
    return g;
  });
};

/** 출현빈도 높은순 기반 게임 생성 (5게임) */
export const getShowCountDesc = async (size = 5): Promise<LottoGame[]> => {
  const results: LottoGame[] = [];
  for (let i = 0; i < size; i++) {
    const res = await api.get("/api/v1/lotto/game/showCountDesc");
    const g = new LottoGame();
    g.bind(res.data);
    results.push(g);
  }
  return results;
};

/** 출현빈도 낮은순 기반 게임 생성 (5게임) */
export const getShowCountAsc = async (size = 5): Promise<LottoGame[]> => {
  const results: LottoGame[] = [];
  for (let i = 0; i < size; i++) {
    const res = await api.get("/api/v1/lotto/game/showCountAsc");
    const g = new LottoGame();
    g.bind(res.data);
    results.push(g);
  }
  return results;
};

/** 동반출현 높은순 기반 게임 생성 */
export const getAccompanyCountDesc = async (): Promise<LottoGame[]> => {
  const res = await api.get("/api/v1/lotto/game/accompanyCountDesc");
  const g = new LottoGame();
  g.bind(res.data);
  return [g];
};

/** 동반출현 낮은순 기반 게임 생성 */
export const getAccompanyCountAsc = async (): Promise<LottoGame[]> => {
  const res = await api.get("/api/v1/lotto/game/accompanyCountAsc");
  const g = new LottoGame();
  g.bind(res.data);
  return [g];
};

/** 자리수 평균값 기반 게임 생성 */
export const getAverageDrwNo = async (): Promise<LottoGame[]> => {
  const res = await api.get("/api/v1/lotto/game/averageDrwNo");
  const g = new LottoGame();
  g.bind(res.data);
  return [g];
};
